import React from "react";

// Components
import DownloaderTable from "./DownloaderTable";

const Downloader = (props) => {
  const {
    isLoading,
    setLoading,
    downloaders,
    fetchAllDownloaders,
    setShowAlertWorkshop,
    setWorkshopAlertMsg,
    navigate,
  } = props;

  return (
    <DownloaderTable
      navigate={navigate}
      isLoading={isLoading}
      fetchAllDownloaders={fetchAllDownloaders}
      setLoading={setLoading}
      downloaders={downloaders}
    />
  );
};

export default Downloader;
